const styles = {
    invictiGreen: '#6CE1AE',
    invictiPurple: '#6B5FC6',
    invictiBlack: '#1D1C29',
    invictiGrey: '#D3DFEA'
}

export default styles;